import { Crosshair } from "lucide-react";
import { PLATFORM_COLORS } from "../lib/constants";

// Auto-generated, on-brand "case file" cover shown when a report has no screenshot.
// Deterministic per player so the Wall of Shame always looks clean and uniform.
export const CaseFilePlaceholder = ({ report, className = "" }) => {
  const tag = (report.gamertag || "?").trim();
  const initials = (tag.replace(/[^a-zA-Z0-9]/g, "").slice(0, 2) || "??").toUpperCase();
  const accent = PLATFORM_COLORS[report.platform] || "#00F0FF";
  const caseNo = (report.id || "").replace(/[^0-9a-fA-F]/g, "").slice(0, 6).toUpperCase().padEnd(6, "0");

  return (
    <div
      data-testid={`case-file-placeholder-${report.id}`}
      className={`relative flex h-full w-full items-center justify-center overflow-hidden bg-[#0B1120] ${className}`}
    >
      <div className="absolute inset-0 grid-texture opacity-30" />
      <div
        className="absolute inset-0"
        style={{ background: `radial-gradient(120% 120% at 50% 0%, ${accent}1f, transparent 62%)` }}
      />
      {/* caution stripe */}
      <div
        className="absolute inset-x-0 top-0 h-1.5"
        style={{ backgroundImage: `repeating-linear-gradient(45deg, ${accent}, ${accent} 6px, transparent 6px, transparent 12px)` }}
      />
      <Crosshair className="absolute -bottom-4 -right-4 text-white/[0.04]" size={110} strokeWidth={1} />

      <div className="relative flex flex-col items-center">
        <div
          className="flex h-14 w-14 items-center justify-center rounded-lg border font-heading text-2xl font-black tracking-tight"
          style={{ borderColor: `${accent}55`, color: accent, backgroundColor: `${accent}12` }}
        >
          {initials}
        </div>
        <span className="mt-2 font-mono text-[9px] uppercase tracking-[0.3em] text-[#64748B]">Case File</span>
        <span className="font-mono text-xs font-bold text-[#94A3B8]">#{caseNo}</span>
      </div>
    </div>
  );
};
